// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { indeterminantCheckbox16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-indeterminant-checkbox': IconIndeterminantCheckbox;
    }
}

/**
 * The icon component for the 'indeterminantCheckbox' icon
 */
export class IconIndeterminantCheckbox extends Icon {
    public constructor() {
        super(indeterminantCheckbox16X16);
    }
}

registerIcon('icon-indeterminant-checkbox', IconIndeterminantCheckbox);
export const iconIndeterminantCheckboxTag = 'nimble-icon-indeterminant-checkbox';
